import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const RouteRedirects: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // Handle redirects from old hash routes to new clean routes
    const path = location.pathname;
    const hash = location.hash;
    
    // Handle hash-based redirects (old hash router URLs)
    if (hash && hash.startsWith('#/')) {
      const hashPath = hash.substring(2); // Remove '#/'
      
      if (hashPath === 'x') {
        navigate('/weaver-x/', { replace: true });
      } else if (hashPath === 'subtext') {
        navigate('/subtext/', { replace: true });
      } else if (hashPath.startsWith('x/game/')) {
        const gameNumber = hashPath.split('/')[2];
        navigate(`/weaver-x/game/${gameNumber}`, { replace: true });
      } else if (hashPath.startsWith('subtext/game/')) {
        const gameNumber = hashPath.split('/')[2];
        navigate(`/subtext/game/${gameNumber}`, { replace: true });
      } else if (hashPath.startsWith('game/')) {
        const gameNumber = hashPath.split('/')[1];
        navigate(`/weaver/game/${gameNumber}`, { replace: true });
      }
      return;
    }
    
    // Handle path-based redirects (clean URLs that need updating)
    if (path === '/x') {
      navigate('/weaver-x/', { replace: true });
    } else if (path.startsWith('/x/game/')) {
      const gameNumber = path.split('/')[3];
      navigate(`/weaver-x/game/${gameNumber}`, { replace: true });
    } else if (path.startsWith('/game/')) {
      const gameNumber = path.split('/')[2];
      navigate(`/weaver/game/${gameNumber}`, { replace: true });
    }
  }, [location.pathname, location.hash, navigate]);

  return null;
};

export default RouteRedirects; 